import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-contact-data-info',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './contact-data-info.component.html',
    styleUrl: './contact-data-info.component.scss',
})
export class ContactDataInfoComponent {

	private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    contactDataInfoTitle = 'features.contactDataInfo.contactDataInfoTitle';
    contactDataInfoSubtitle = 'features.contactDataInfo.contactDataInfoSubtitle';
    emailLabel = 'features.contactDataInfo.emailLabel';
    infoEmail = 'features.contactDataInfo.infoEmail';
    telephoneLabel = 'features.contactDataInfo.telephoneLabel';
    infoTelephone = 'features.contactDataInfo.infoTelephone';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(5);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.setValuesForm(this.appData.data.userData);

        this.formIsValid();
    }

    createForm() {
        this.formGroup = this.fb.group({
            email: new FormControl('', [Validators.required, Validators.minLength(1), Validators.email]),
            telephone: new FormControl('', [
                Validators.required,
                Validators.minLength(9),
                Validators.maxLength(9),
                Validators.pattern(/^-?(0|[1-9]\d*)?$/),
            ]),
        });
    }


    setValuesForm(value?: any) {
        if (value != undefined) {
            this.formGroup = this.fb.group({
                email: new FormControl(value.contactDataInfo.email ? value.contactDataInfo.email : '', [Validators.required, Validators.minLength(1), Validators.email]),
                telephone: new FormControl(value.contactDataInfo.telephone ? value.contactDataInfo.telephone : '', [
                    Validators.required,
                    Validators.minLength(9),
                    Validators.maxLength(9),
                    Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                ])
            });
        }
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    onChangeEmail(event: Event) {
        this.formIsValid();
    }

    onChangeTelephone(event: Event) {
        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'contact-data-info');
        this.router.navigate(['/main/step/personal-data-birth'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'contact-data-info');
        this.router.navigate(['/main/step/house-address'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
